import { render, staticRenderFns } from "./ModalFormProveedor.vue?vue&type=template&id=58115f29"
import script from "./ModalFormProveedor.vue?vue&type=script&lang=js"
export * from "./ModalFormProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports